import "@/build-stamp";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Set Mews configuration ID from environment variables
if (import.meta.env.VITE_MEWS_CONFIGURATION_ID) {
  (window as any).MEWS_CONFIG_ID = import.meta.env.VITE_MEWS_CONFIGURATION_ID;
  // Only log in development mode
  if (import.meta.env.DEV) {
    console.log(
      "Mews Configuration ID set from environment:",
      import.meta.env.VITE_MEWS_CONFIGURATION_ID,
    );
  }
}

createRoot(document.getElementById("root")!).render(<App />);
